import React from "react";
import {IApplicationInternal} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {Button, Dialog, DialogActions, DialogContent, Divider} from "@material-ui/core";
import {
    AppInfoContainer,
    DetailTitle,
    DetailValue,
    StyledCheckbox,
} from "./styles";
import {Values} from "Tools/Values";
import {InternalAppDetailsItem} from "./InternalAppDetailsItem/InternalAppDetailsItem";
import {InternalAppDetailsToken} from "./InternalAppDetailsToken/InternalAppDetailsToken";
import { InternalAppDetailsHeader } from "./InternalAppDetailsHeader/InternalAppDetailsHeader";
import { InternalAppDetailsScopes } from "./InternalAppDetailsScopes/InternalAppDetailsScopes";

interface IProps {
    app: IApplicationInternal;
    isOpened: boolean;
    onClose: () => void;
}

export const InternalAppDetailsDialog = ({app, isOpened, onClose}: IProps) => (
    <Dialog
        maxWidth="sm"
        open={isOpened}
        onClose={() => onClose()}
    >

        <DialogContent style={{minWidth: 500, paddingBottom: 32}}>
            <InternalAppDetailsHeader app={app}/>

            <InternalAppDetailsScopes scopes={app.scopes}/>

            <InternalAppDetailsItem
                title={Values.getLocalizationValue('applicationUrl')}
                value={app.url}
            />

            <AppInfoContainer>
                <DetailTitle>{Values.getLocalizationValue('options')}</DetailTitle>
                <Divider/>
                <DetailValue style={{padding: 0}}>
                    {`${Values.getLocalizationValue('displayInAppDrawer')}: `}
                    <StyledCheckbox checked={app.displayInDrawer}/>
                </DetailValue>
            </AppInfoContainer>

            <InternalAppDetailsItem
                title={Values.getLocalizationValue('id')}
                value={app.clientId}
            />

            <InternalAppDetailsToken
                token={app.token}
                expiresAt={app.expiresAt}
            />

        </DialogContent>

        <DialogActions style={{padding: 16}}>
            <Button
                variant="contained"
                onClick={onClose}
                color="default"
            >
                {Values.getLocalizationValue('close')}
            </Button>
        </DialogActions>
    </Dialog>
)
